<div class="grid-container padding-y-4">
  @if (notRouted) {
    <button class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="closeModal()">
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
        <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
      </svg>
    </button>
  }
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">{{title}}</legend>
    </div>
  </div>
  <form [formGroup]="notificationsPreferencesForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap">
        @if (showBusType) {
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="business_type" class="usa-label">Business Type<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="business_type" formControlName="businessType" class="usa-select" title="state" name="state"
              (change)="businessTypeChange($event.target.value)">
              <option [value]='null' selected disabled>Choose...</option>
              <option value='FRT'>FRT</option>
              <option value='HHG'>HHG</option>
            </select>
          </div>
        }

        @if (showNotifType) {
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="notification_type" class="usa-label">Notification Type<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="notification_type" class="usa-select maxw-full" formControlName="notificationType"
              (change)="notificationTypeChange($event.target.value)" required>
              <option value='' selected disabled>Choose...</option>
              @for (type of notifTypes ; track type) {
                <option [value]="type">{{type}}</option>
              }
            </select>
          </div>
        }
      </div>

      @if (showDataFields) {
        <div class="grid-row grid-gap">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label for="email" class="usa-label">Enter Email(s) to Receive Selected Notification (Note: To add additional emails, separate each one with a comma.  At least one email must be entered/displayed below.)<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="email" formControlName="email" class="usa-input" [maxlength]="254">
            @if (this.notificationsPreferencesForm.get('email').touched
              && this.notificationsPreferencesForm.get('email').hasError('required')) {
              <div>
                <small class="text-danger">
                  <span class="fa fa-warning"></span> At least one email is required
                </small>
              </div>
            }
          <!--<div *ngIf="this.notificationsPreferencesForm.get('email').touched
                                && this.notificationsPreferencesForm.get('email').hasError('emailPattern')">
            <small class="text-danger">
              <span class="fa fa-warning"></span> Email is invalid
            </small>
          </div>-->
          @if (this.notificationsPreferencesForm.get('email').touched
            && this.notificationsPreferencesForm.get('email').hasError('emailPattern')) {
            <div>
              <small class="text-danger">
                <span class="fa fa-warning"></span> One of the email ids is invalid
              </small>
            </div>
          }
        </div>
      </div>
    }
    @if (!notRouted) {
      <div>
        <hr>
          <div>
            <div class="grid-row">
              <legend class="usa-legend usa-legend--medium">Auth Official Information for Account</legend>
            </div>
            <div class="grid-row"><label class="usa-label">Auth Official Name : {{ pocInfo?.firstName }} {{ pocInfo?.lastName }}</label></div>
            <div class="grid-row"><label>Phone : {{ pocInfo?.phone }}</label></div>
            <div class="grid-row"><label>Email : {{ pocInfo?.email }}</label></div>
            <div class="grid-row"></div>
          </div>
        </div>
      }

      @if (notRouted) {
        <div>
          <br>
          </div>
        }

        <button type="button" class="usa-button margin-top-2" [disabled]="this.notificationsPreferencesForm.invalid"
          (click)="saveNotifPrefs();">Save
        </button>

        <button type="button" class="usa-button margin-top-2" (click)="onViewAuditTrail()">View Audit Trails
        </button>

      </fieldset>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
  </div>

